import packageInfo from '../../../package.json';

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyByk3eAu3IBeqnmQ9WGOM0BfqjAXf3KOjs',
    authDomain: 'dev-closecare2c.firebaseapp.com',
    databaseURL: 'https://dev-closecare2c.firebaseio.com',
    projectId: 'dev-closecare2c',
    storageBucket: 'dev-closecare2c.appspot.com',
    messagingSenderId: '407716069242',
    appId: '1:407716069242:web:9f085f65dc1462d4f860c3'
  },
  // Temporarily the enviei b2c widget (dev): the backend validates every
  // /v4/b2c/people/auth token against a single TURNSTILE_B2C_SECRET, so
  // atestado.me must use the enviei widget for now (its hostnames must include
  // dev.atestado.me). Switch to the atestado widget '0x4AAAAAAD7ZyQozPU2XZo2T'
  // once business_care supports TURNSTILE_B2C_ATESTADO_SECRET per domain.
  turnstile_key: '0x4AAAAAAA7qI2fCLquTmWzr',
  sentryDsn: 'https://27aaace71864425a81a7297f3d6f3899@o373977.ingest.sentry.io/5430093',
  closecareApiKey: 'AIzaSyAGmJUO2H91Sj2blXrez-yJogOZxaE_VSU',
  intercomAppId: 'pijdcech',
  intercomArticles: {
    // The dev Intercom workspace (pijdcech) does not host these Help Center articles,
    // so they stay empty and openSupport falls back to the messenger. Real ids in prod.ts.
    'track-status': '',
    'rejection-reason': '',
  },
  version: packageInfo.version
};

export const AUTHENTICATED_DOMAINS = [
  'localhost',
  'closecare.com.br',
  'nustro-aaf4f.appspot.com',
  'firebasestorage.googleapis.com',
  'esp-apis-v3-ydd63pv53q-uc.a.run.app'
];
